import { getAccessToken } from './auth';

const MEMBER_SEARCH_URL = 'https://fp-api.focuspointintl.com/api/data/';

export function isMemberRecordActive(record) {
  const today = new Date();
  const startDate = record?.Start ? new Date(record.Start) : null;
  const endDate = record?.End ? new Date(record.End) : null;
  return Boolean(startDate && endDate && today >= startDate && today <= endDate);
}

export async function fetchMembersBySearch(searchTerm) {
  const term = String(searchTerm || '').trim();
  if (!term) return [];

  const accessToken = await getAccessToken();
  if (!accessToken) throw new Error('Could not get access token');

  const url = `${MEMBER_SEARCH_URL}?searchpass=${encodeURIComponent(term)}`;
  const response = await fetch(url, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || 'Member search failed');
  }

  const data = await response.json();
  return Array.isArray(data) ? data : [];
}

/** Prefer rows that match the searched email exactly; fall back to full API list. */
export function pickMemberResultsForEmail(records, email) {
  if (!Array.isArray(records) || records.length === 0) return [];
  const normalized = String(email || '').trim().toLowerCase();
  if (!normalized) return records;

  const exact = records.filter((row) => String(row.Email || '').trim().toLowerCase() === normalized);
  return exact.length > 0 ? exact : records;
}
